export default __webpack_public_path__ + "assets/InfoCircle.f28a.svg";